export function getEnvironment() {
  const config = useRuntimeConfig();

  return config.public.BACKEND_URL.includes('rocks') ? 'staging' : 'production';
}

export function isStaging() {
  return process.env.NODE_ENV === 'staging';
}

export function isDevelopment() {
  return process.env.NODE_ENV === 'development';
}
